// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 274 ? "152ccbd5" : chunkId) + "." + {"274":"738c1acc328e0c5e","713":"652bc51388d271ca"}[chunkId] + ".js";
};